import { Component, OnInit, Input } from '@angular/core';
import { SharedService } from 'src/app/services/shared/shared.service';
import { NavigationExtras, Router } from '@angular/router';
import { LabelService } from 'src/app/services/label/label.service';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { encodeURL } from 'src/app/services/parseURL';
import {DomSanitizer} from '@angular/platform-browser';
@Component({
  selector: 'app-widget-images-banner',
  templateUrl: './widget-images-banner.component.html',
  styleUrls: ['./widget-images-banner.component.scss'],
})
export class WidgetImagesBannerComponent implements OnInit {
  @Input() widgetID: any;
  @Input() widgetTitle: any;
  @Input() widgetIndex: any;
  images: any = [];
  SHOP_CATEGORIES_LABELS: any = {};
  SHARED_LABELS: any = {};
  searchPlaceholder = '';
  imgLoaded = false;
  popupData: any;
  BANNER_SETTINGS_LABELS: any;
  CO_CATEGORY_GRID_LABELS: any;
  RFQFeature = false;
  promoVideo: any;
  deviceWidth:any;
  widgetStyle:any;
  background:any ;
  data:any = {};
 
  constructor(
    private widgetsService:WidgetsService,
    private labelService:LabelService,
    private sharedService: SharedService,
    private utilsService:UtilsService,
    private domSanitizer:DomSanitizer,
     private router: Router,) { }

  ngOnInit() {
    this.initializeSubscriptions();
    this.BANNER_SETTINGS_LABELS = this.labelService.labels['BANNER_SETTINGS'];
    this.SHARED_LABELS = this.labelService.labels['SHARED'];
    console.log('this is data variable',this.data);
  }
  ionViewWillEnter() {
    
  }

  async initializeSubscriptions(){
    let widgetData: any = await this.widgetsService.getWidgetData(this.widgetID);
    //this.utilsService.consoleLog('widget-images-banner:47 widgetData', widgetData);
    if (widgetData && widgetData.style && widgetData.style.widgetStyle && Object.keys(widgetData.style.widgetStyle).length != 0) {
      this.widgetStyle = widgetData.style.widgetStyle;
      this.data.widgetStyle = this.widgetStyle;
      if(this.widgetStyle.backgroundImage){
          this.background = this.domSanitizer.bypassSecurityTrustStyle(`url(${this.widgetStyle.backgroundImage})`);
          this.data.background = this.background;
      }
      else if(this.widgetStyle.backgroundColor){
          this.background = this.widgetStyle.backgroundColor;
          this.data.background = this.background;
      }
      else{
         // this.background = 'transparent';
          //this.data.background = 'transparent';
      }
  }
   
   
    this.deviceWidth = this.utilsService.getDeviceWidth();
        this.utilsService.consoleLog('device width', this.deviceWidth);
        if (this.deviceWidth > 786) {
            let data: any = await this.widgetsService.getWebImagesForBanner(this.widgetID);
            if (data && data.length) {
                this.images = data;
                this.data.images = data;
            }
        } else {
            let data: any = await this.widgetsService.getMobImagesForBanner(this.widgetID);
            if (data && data.length) {
                this.images = data;
                this.data.images = data;
            }
        }
  }
  async onClickBanner(bannerData: any) {
    this.widgetsService.bannerLink(bannerData);
  }

  getUrlTxt(value: string) {
    return encodeURL(value);
  }
}
